<div class="countable-dialog w-100" (click)="$event.stopPropagation()" style="max-width: 400px;">
  <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
    <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
    </span>
    <h4 class="title text-center">{{dialogboxHeader}}</h4>
    <!-- <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
    </button> -->
  </div>

  <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
    <p>{{dialogboxText}}</p>
    <p>{{dialogboxAdditionalText}}</p>
  </div>

  <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false" (click)="dialogRef?.close(false)">{{cancelAction}}</button>
      <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true" (click)="dialogRef.close(true)">{{confirmAction}}</button>
  </div>
</div>
